import * as $            from 'jquery';
import { onClick }       from 'Core/Events';
import "bootstrap/js/src/modal";

export class DepartmentsModal {

    private static Selector = {
        MODAL: "#global_departments",
        LINKS: ".js_departments_preview",
        LOADER: '#modal_preloader'
    };

    @onClick(DepartmentsModal.Selector.LINKS, DepartmentsModal.openDepartmentsModal)

    private static openDepartmentsModal(this: HTMLAnchorElement, event: JQuery.Event) {

        event.preventDefault();
        event.stopPropagation();

        const $this                          = $(this);
        const url                            = $this.attr('href');

        if (url) {
            $.get(url)
                .done(data => DepartmentsModal.handleResponse(data));
        }

        return false;
    }

    /**
     * Zaawansowana obsługa response czyli ifologia
     *
     * @param data
     * @private
     */
    private static handleResponse(data)
    {
        const $modal                         = $(DepartmentsModal.Selector.MODAL);
        const modalBody: JQuery<HTMLElement> = $modal.find('.modal-body');

        if(data.link){
            window.location.assign(data.link);
        } else {
            $modal.modal("show");
            $(DepartmentsModal.Selector.LOADER).removeClass('d-none');
            modalBody.html(data.tpl)
        }
    }

}
import * as $            from 'jquery';
import { onClick }       from 'Core/Events';
import "bootstrap/js/src/modal";

export class DepartmentsModal {

    private static Selector = {
        MODAL: "#global_departments",
        LINKS: ".js_departments_preview",
        LOADER: '#modal_preloader'
    };

    @onClick(DepartmentsModal.Selector.LINKS, DepartmentsModal.openDepartmentsModal)

    private static openDepartmentsModal(this: HTMLAnchorElement, event: JQuery.Event) {

        event.preventDefault();
        event.stopPropagation();

        const $this                          = $(this);
        const url                            = $this.attr('href');

        if (url) {
            $.get(url)
                .done(data => DepartmentsModal.handleResponse(data));
        }

        return false;
    }

    /**
     * Zaawansowana obsługa response czyli ifologia
     *
     * @param data
     * @private
     */
    private static handleResponse(data)
    {
        const $modal                         = $(DepartmentsModal.Selector.MODAL);
        const modalBody: JQuery<HTMLElement> = $modal.find('.modal-body');

        if(data.link){
            window.location.assign(data.link);
        } else {
            $modal.modal("show");
            $(DepartmentsModal.Selector.LOADER).removeClass('d-none');
            modalBody.html(data.tpl)
        }
    }

}
